export default __webpack_public_path__ + "static/media/3.fe72d861.webp";